<mat-form-field class="autocomplete-input" [class.list-selected]="listSelected" (mouseover)="listSelected=true"
    (mouseout)="listSelected=false">
    <mat-chip-grid class="chip-block" #chipList aria-label="Category selection">
        @if (showChips) {
            @for (item of selectedItems; track item) {
            <mat-chip-row selectable="false" [removable]="true" (removed)="onRemove(item)">
                {{item?.name || item}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            }
        }
        <input #searchTextInput matInput type="text" [(ngModel)]="inputValue" [placeholder]="" [formControl]="inputValueControl"
            (click)="onFocus()" [matAutocomplete]="auto" autocomplete="chrome-off" [matChipInputFor]="chipList">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" class="mat-select-panel" [autoActiveFirstOption]="true"
        (closed)="applyFilter()" panelWidth="auto">
        @if (selectAll && isCheckbox) {
        <div class="select-all">
            <mat-checkbox (click)="$event.stopPropagation()"
                (change)="optionSelected(selectedItems.length === data.length ? 'Unselect All' : 'Select All')"
                [checked]="selectedItems && data && selectedItems.length === data.length">
                {{ selectedItems && data && selectedItems.length === data.length ? "Unselect All" : "Select All" }}
            </mat-checkbox>
        </div>
        }

        @for (option of data | slice:0:maxDataRows; track option; let last = $last) {
        <mat-option (onSelectionChange)="optionSelected(option)" [value]="option">
            @if (!isCheckbox) {
            <span [class.selected-item]="isSelected(option)">
                {{ option?.name || option }}
            </span>
            }
            @if (isCheckbox) {
            <mat-checkbox (click)="$event.stopPropagation()" (change)="optionSelected(option)"
                [checked]="isSelected(option)">
                {{ option?.name || option}}
            </mat-checkbox>
            }
        </mat-option>
        }

        @if (data && data.length >= maxDataRows) {
        <div class="over-records">
            <span>Displaying 1st {{maxDataRows}} results.</span><br />
            <span>Keep typing to refine further.</span>
        </div>
        }
    </mat-autocomplete>
    @if (selectedItems?.length > 1) {
    <button mat-icon-button class="icon-close" aria-label="close" (click)="clearAll()">
        <mat-icon>close</mat-icon>
    </button>
    }
</mat-form-field>